<div class="grid min-h-0 grid-cols-2 h-full p-4">
	<div class="data-section">
		<div class="title">
			<h2>Closer Mortgage</h2>
			<app-button (click)="copyCloserMortgageJSON()" size="small"
				>Copy</app-button
			>
		</div>
		<div class="data">
			<ngx-json-viewer [json]="closerMortgage"></ngx-json-viewer>
		</div>
	</div>
	<div
		class="data-section"
		*ngIf="closerMortgage.type === MatterMortgageType.LLC"
	>
		<div class="title">
			<h2>LLC Mortgage</h2>
			<app-button (click)="copyLLCJSON()" size="small">Copy</app-button>
		</div>
		<div class="data">
			<ngx-json-viewer [json]="llcMortgage$ | async"></ngx-json-viewer>
		</div>
	</div>
	<div
		class="data-section"
		*ngIf="closerMortgage.type === MatterMortgageType.CLOSER_SYNC"
	>
		<div class="title">
			<h2>Closer SYNC Mortgage</h2>
			<app-button (click)="copyCloserSyncJSON()" size="small">Copy</app-button>
		</div>
		<div class="data">
			<ngx-json-viewer [json]="closerSyncJSON"></ngx-json-viewer>
		</div>
	</div>
</div>
